export const PREMIUM_LIMITS = {
  FREE_TIER_MAX_CLIENTS: 2,
  PRO_TIER_MAX_CLIENTS: 10,
  FREE_TIER_MAX_COMPANIES: 1,
  PRO_TIER_MAX_COMPANIES: 5
}